
import { mapGetters } from "vuex"
import colors from "@/mixins/colors"
import Swiper from "swiper"
import "swiper/swiper.scss"
import Hashtag from "@/components/base/Hashtag"

export default {
    name: "TagFilter",
    components: { Hashtag },
    mixins: [colors],
    props: {
        maxTags: {
            type: Number,
            default: 20,
        },
        jobCategory: {
            type: String,
        },
    },
    data: () => ({
        tags: [],
        swiper: null,
        loading: false,
    }),
    watch: {
        $route(to, from) {
            if (to.query.category != from.query.category) {
                this.tags = []
                this.getTags()
            }
        },
    },
    mounted() {
        this.getTags()
        this.initSwiper()
    },
    methods: {
        initSwiper() {
            this.swiper = new Swiper(this.$refs["swiper"], {
                slidesPerView: "auto",
                freeMode: true,
                direction: "horizontal",
            })
        },
        getTags() {
            this.loading = true
            let searchParams = {
                filters: this.filter,
                scope: this.jobCategory,
                channel: this.channel,
            }
            this.$axios
                .$get("/api/search/tags", {
                    params: searchParams,
                })
                .then((response) => {
                    var shuffledTags = response.data
                    for (var i = shuffledTags.length - 1; i > 0; i--) {
                        var j = Math.floor(Math.random() * (i + 1))
                        var temp = shuffledTags[i]
                        shuffledTags[i] = shuffledTags[j]
                        shuffledTags[j] = temp
                    }
                    this.tags = shuffledTags.slice(0, this.maxTags - 1)
                    this.loading = false
                    setTimeout(() => {
                        this.swiper.update()
                    }, 50)
                })
        },
        removeTag() {
            let queryParams = { ...this.$route.query }
            delete queryParams.tags
            this.$router.push({ query: queryParams })
        },
    },
    computed: {
        ...mapGetters("search", [
            "filterName",
            "location",
            "filter",
            "channel",
            "route",
        ]),
        filteredTags() {
            var sorted = this.tags.filter((tag) => {
                return tag != this.filter.tags
            })
            if (this.filter.tags) {
                sorted.unshift(this.filter.tags)
            }
            return sorted
        },
    },
}
